var groupSelector = {
  version: "2.1.0",
  nameApp: "Prueba en casa", 
  max_selects: 4,
  variantGlasses: (typeof collecprb2_product_variant != 'undefined'?collecprb2_product_variant: ""),
  variants: [],
  isProductBuilder: false,
  builderIntervalObj: null,
  showMessage: function(objEl, strMsg){
    objEl.html('<p>'+strMsg+'</p>');
    objEl.show();
    setTimeout(function(){
      objEl.hide();
    }, 1500);
  }, 
  clearCart: function(){
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      dataType: 'json',
      success: function(){
        //ADD TO CART
        let arrCartJS = [];
        groupSelector.variants.map(function(v){
          arrCartJS.push({
            quantity: 1, 
            id: v
          });
        });
        
        //agregando product glasses
        if(groupSelector.variantGlasses != ""){
          arrCartJS.push({
            quantity: 1, 
            id: parseInt(groupSelector.variantGlasses)
          });
        }
		
        $.post('/cart/add.js', {
          items: arrCartJS
        }).done(function(rs){
          top.location.href = "/cart";
        });
      }
    });
  },
  getCart: function(){
    fetch("/cart.json").then( result => {
      if (result.status === 200) {
        return result.json();
      }
      return null;
    }).then( resJson => {
      
      //VARIANTS IN CART
      let variantsInCart = [];
      for(var z=0; z<resJson.items.length; z++){
        variantsInCart.push(resJson.items[z].variant_id);
      }//end for
      
      //ADD TO CART
      let arrCartJS = [];
      groupSelector.variants.map(function(v){
        if(variantsInCart.indexOf(v)===-1){
          arrCartJS.push({
            quantity: 1, 
            id: v
          });
        }
        console.log('hola ',groupSelector.variants);
      });
	  console.log(groupSelector.variants + ' variantes');
      console.log(arrCartJS);
      
      if(arrCartJS.length > 0){
        $.post('/cart/add.js', {
          items: arrCartJS
        }).done(function(rs){
          top.location.href = "/cart";
        });
      }else{
        top.location.href = "/cart";
      }
      
    });
  }, 
  removeItem: function(data, callback){
    fetch("/cart/change.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            ...data,
            quantity: 0
        })
    }).then( result => {
      if (result.status === 200) {
        return result.json();
      }
      return null;
    }).then( resJson => {
      console.log(resJson);
      groupSelector.removeItemAll(callback);
    });
  }, 
  removeItemAll: function(data){
    let newArrData = [];
    let currentData = null;
    for(let i=0; i<data.length; i++){
      if(i===0){
        currentData = data[i];
      }else{
        newArrData.push(data[i]);
      }
    }
    if(currentData){
      groupSelector.removeItem({ id: currentData }, newArrData);
    }else{
      localStorage.clear();
      location.reload();
    }
  }, 
  formatMoney: function(number, decPlaces, decSep, thouSep){
    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
      decSep = typeof decSep === "undefined" ? "." : decSep;
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    var sign = (number < 0 ? "-" : "+")+"$";
    var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
    //var j = (j = i.length) > 3 ? j % 3 : 0;
    var j = (j = i.length) > 3 ? (j-3) : 0;
    return sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
  },
  cleanTextTitles: function(strText){
    for(var i=0; i<20; i++){
      strText = strText.replace('{'+i+'}','');
    }
    return strText;
  },
  builderInitInterval: function(){
    const that = this;
    const $container = $('.product-block-list__item--build form[action="/cart/add"] #bcpo');
    let initIteration = 1;
    if(typeof window.productJSON !== "undefined"){
      if(productJSON.options.length===1 && productJSON.options[0].toUpperCase()==="TITLE"){
        initIteration = 0;
      }
    }
    
    if($container.length && !that.isProductBuilder){
      const itemsBuild = $container.find('div[data-unique]');
      if(itemsBuild.length >= 0){
        
        let hideAllComponents = true;
        that.isProductBuilder = true;
        clearInterval(that.builderIntervalObj);
        
        $(".product-form__submit-container").find('[type="submit"]').hide();
        $(".product-form__submit-container").find('[type="submit"]').after('<div class="group-builder-trigger-1" style="width:100%;margin:0;"></div>');
        
        let htmlBlock = '';
        let iteration = 0;
        itemsBuild.each(function(){
          const bcpoContainer = $(this);
          const bcpoLabel = bcpoContainer.find(".bcpo-label");
          const bcpoDiv = bcpoLabel.next();
          const title = groupSelector.cleanTextTitles(bcpoLabel.find("label .bcpo-title").html());
          
          if(iteration>=initIteration){
            if(iteration===0){
              iteration++;
            }
            let isItemVisible = (bcpoLabel.is(":visible")?"build-dw-visible":"build-dw-hidden")+" build-dw-config";
            bcpoContainer.addClass("build-dw-container-"+iteration).addClass(isItemVisible);
            bcpoLabel.addClass("build-dw-label-"+iteration);
            bcpoDiv.addClass("build-dw-div-"+iteration);
            
            if(iteration === 1 && bcpoDiv.find(".bcpo-button-parent label").length){
              let childOpt = 0;
              bcpoDiv.find(".bcpo-button-parent label").each(function(){
                let cloneLabel = $(this).clone();
                /*if(childOpt===0){
                  $("#"+cloneLabel.attr("for")).trigger("click");
                }*/
                cloneLabel.attr("class", "button button--primary button--builder-trigger button--builder-box"+($("#"+cloneLabel.attr("for")).is(":checked")?"is-checked":""));
                cloneLabel.attr("data-step", iteration);
                $(".group-builder-trigger-1").append(cloneLabel);
                childOpt++;
              });
            }
            if(iteration >= 2){
              hideAllComponents = false;
              htmlBlock += '<div class="data-builder-item--container" data-step="'+iteration+'">';
              	htmlBlock += '<div class="builder-header">'+title+'</div>';
              	htmlBlock += '<div class="builder-body">';
              	
                bcpoDiv.find('input[type="radio"]').each(function(){
                  const currPrice = $(this).attr("data-price");
                  const currLabel = $(this).parent().find('label');
                  const itemPrice = groupSelector.formatMoney(currPrice, 0, ',', '.');
                  htmlBlock += '<label data-step="'+iteration+'" data-price="'+(itemPrice==='+$0'?'INCLUÍDO':itemPrice)+'" class="'+currLabel.attr('class')+' button--builder-trigger button--builder-pic" style="'+currLabel.attr('style')+'" for="'+currLabel.attr('for')+'"></label>';
                });
              	
              	if(bcpoDiv.find('input[type="radio"]').length===0 && bcpoDiv.find('input[type="file"]').length>0){
                  bcpoDiv.find('input[type="file"]').each(function(){
                    htmlBlock += '<label data-step="'+iteration+'" data-file="'+$(this).attr("name")+'" class="button--builder-trigger button--builder-file">Haz click aquí para cargar tu archivo</label>';
                  });
                }
              
                htmlBlock += '</div>';
              htmlBlock += '</div>';
            }
          }//end if
          
          iteration++;
        });
        $('.group-builder-trigger-2').attr('data-currstep', '2');
        $('.group-builder-trigger-2').html(htmlBlock);
        if(hideAllComponents){
          $('.group-builder-trigger-2').hide();
        }else{
          $('.group-builder-trigger-2').show();
          $('.data-builder-item--container[data-step="2"]').addClass('is-item-visible');
        }
        
        /*IMAGEN*/
        let variant_id = '';
        if((window.location.href).toString().includes('variant=')){
          variant_id = (((window.location.href).toString()).split('variant='))[1];
          if(variant_id.includes('&')){
            variant_id = variant_id.split('&')[0];
          }
        }else if($('#shopify-virtooal-variants option').length>0){
          if($('#shopify-virtooal-variants').val()!==""){
            variant_id = $('#shopify-virtooal-variants').val();
          }else{
            $('#shopify-virtooal-variants option').each(function(){
              if(variant_id==="" && $(this).attr("value")!==""){
                variant_id = $(this).attr("value");
              }
            });
          }
        }
        if($('#shopify-virtooal-variants option[value="'+variant_id+'"]').length){
          let imgUrl = $('#shopify-virtooal-variants option[value="'+variant_id+'"]').attr('data-imagesrc');
          let variantTitle = $('#shopify-virtooal-variants option[value="'+variant_id+'"]').attr('data-title');
          if(imgUrl.trim()===''){
            imgUrl = $('#shopify-virtooal-variants option[value=""]').attr('data-imagesrc');
            variantTitle = $('#shopify-virtooal-variants option[value=""]').attr('data-title');
          }
          if(imgUrl!==""){
            let htmlControl = '';
            htmlControl += '<button type="button" class="btn-prev-next-build-steps prev" style="display:none;">';
            htmlControl += '<svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">';
            htmlControl += '<path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>';
            htmlControl += '</svg>';
            htmlControl += ' Anterior';
            htmlControl += '</button>';
            htmlControl += '<img src="'+imgUrl+'" alt="'+$('#shopify-virtooal-variants').attr('data-title')+'"/>';
            htmlControl += '<label class="footer-title">'+variantTitle+'</label>';
            htmlControl += '<label class="footer-price">'+$('.product-form__info-content .price.money').html()+'</label>';
            htmlControl += '<button type="button" class="btn-prev-next-build-steps next">';
            htmlControl += 'Siguiente ';
            htmlControl += '<svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">';
            htmlControl += '<path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>';
            htmlControl += '</svg>';
            htmlControl += '</button>';
            $('.group-builder-trigger-3').html(htmlControl);
          }
        }
        
      }//end if
      let submitIsDisabled = false;
      if($('.product-form__info-content .product-form__inventory.inventory').length){
        const inventory = $('.product-form__info-content .product-form__inventory.inventory').html().toUpperCase();
        if(inventory==="AGOTADO"){
          //submitIsDisabled = true;
          $(".group-builder-trigger-1").find(".button--builder-trigger").eq(0).attr("disabled", "disabled");
          $(".group-builder-trigger-1").find(".button--builder-trigger").eq(0).addClass('button--disabled');
        }
      }
      
    }
  },
  formatProductBuilder: function(){
    const that = this;
    that.builderIntervalObj = setInterval(that.builderInitInterval, 1000);
  }, 
  triggerChangeStep: function(currentStep){
    let hideAllComponents = true;
    let isNextStepAv = true;
    let lastItemVisible = 0;
    let componentToHide = parseInt(currentStep);
    let componentToShow = componentToHide+1;
    const $container = $('.product-block-list__item--build form[action="/cart/add"] #bcpo');
    const itemsBuild = $container.find('div[data-unique]');
    
    let initIteration = 1;
    if(typeof window.productJSON !== "undefined"){
      if(productJSON.options.length===1 && productJSON.options[0].toUpperCase()==="TITLE"){
        initIteration = 0;
      }
    }
    if(itemsBuild.length > 0){
      let iteration = 0;
      itemsBuild.each(function(){
        if(initIteration===0&&iteration===0){
          iteration++;
        }
        const bcpoContainer = $(this);
        const bcpoLabel = bcpoContainer.find(".bcpo-label");
        const bcpoDiv = bcpoLabel.next();
        const title = bcpoLabel.find("label .bcpo-title").html();
        let isItemVisible = bcpoLabel.is(":visible");
        if($('.data-builder-item--container[data-step="'+iteration+'"]').length){
          if(isItemVisible){
            $('.data-builder-item--container[data-step="'+iteration+'"]').addClass('prepared-to-show');
          }else{
            $('.data-builder-item--container[data-step="'+iteration+'"]').removeClass('prepared-to-show');
          }
        }
        if(iteration > 1 && isItemVisible){
          hideAllComponents = false;
        }
        if(iteration === componentToShow && !isItemVisible){
          isNextStepAv = false;
        }
        if(iteration > componentToShow && !isNextStepAv && isItemVisible){
          isNextStepAv = true;
          componentToShow = iteration;
        }
        if(isItemVisible){
          lastItemVisible = iteration;
        }
        iteration++;
      });
    }
    if(lastItemVisible<componentToShow && isNextStepAv){
      isNextStepAv = false;
    }
    if(hideAllComponents){
      $('.group-builder-trigger-2').hide();
    }else{
      $('.group-builder-trigger-2').show();
    }
    
    
    /*IMAGEN*/
    if((window.location.href).toString().includes('variant=')){
      let variant_id = (((window.location.href).toString()).split('variant='))[1];
      if(variant_id.includes('&')){
        variant_id = variant_id.split('&')[0];
      }
      if($('#shopify-virtooal-variants option[value="'+variant_id+'"]').length){
        let imgUrl = $('#shopify-virtooal-variants option[value="'+variant_id+'"]').attr('data-imagesrc');
        let variantTitle = $('#shopify-virtooal-variants option[value="'+variant_id+'"]').attr('data-title');
        if(imgUrl.trim()===''){
          imgUrl = $('#shopify-virtooal-variants option[value=""]').attr('data-imagesrc');
          variantTitle = $('#shopify-virtooal-variants option[value=""]').attr('data-title');
        }
        if(imgUrl!==""){
          let htmlControl = '';
          htmlControl += '<button type="button" class="btn-prev-next-build-steps prev" '+(componentToShow<=2?'style="display:none;"':'')+'>';
            htmlControl += '<svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">';
            	htmlControl += '<path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>';
            htmlControl += '</svg>';
            htmlControl += ' Anterior';
          htmlControl += '</button>';
          htmlControl += '<img src="'+imgUrl+'" alt="'+$('#shopify-virtooal-variants').attr('data-title')+'"/>';
          htmlControl += '<label class="footer-title">'+variantTitle+'</label>';
          htmlControl += '<label class="footer-price">'+$('.product-form__info-content .price.money').html()+'</label>';
          htmlControl += '<button type="button" class="btn-prev-next-build-steps next" '+(!isNextStepAv?'disabled="disabled"':'')+'>';
            htmlControl += 'Siguiente ';
            htmlControl += '<svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">';
            	htmlControl += '<path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>';
            htmlControl += '</svg>';
          htmlControl += '</button>';
          $('.group-builder-trigger-3').html(htmlControl);
        }
      }
    }
    
    /*STEP ITEM*/
    if(parseInt(currentStep) >= 2 && isNextStepAv){
      $('.data-builder-item--container[data-step="'+componentToHide+'"]').removeClass('is-item-visible');
      $('.data-builder-item--container[data-step="'+componentToShow+'"]').addClass('is-item-visible');
      $('.group-builder-trigger-2').attr('data-currstep', componentToShow);
      
      if($('[data-step="'+componentToShow+'"] .button--builder-trigger.is-checked').length>0){
        /* ACTIVA O DESACTIVA BOTONES NEXT Y SUBMIT */
        groupSelector.triggerButtonClick(componentToShow);
      }
    }//endif
  }, 
  triggerButtonClick: function(currentStep){
    let hideAllComponents = true;
    let isNextStepAv = true;
    let lastItemVisible = 0;
    let componentToHide = parseInt(currentStep);
    let componentToShow = componentToHide+1;
    
    let initIteration = 1;
    if(typeof window.productJSON !== "undefined"){
      if(productJSON.options.length===1 && productJSON.options[0].toUpperCase()==="TITLE"){
        initIteration = 0;
      }
    }
    
    let firstStepAv = -1;
    const $container = $('.product-block-list__item--build form[action="/cart/add"] #bcpo');
    const itemsBuild = $container.find('div[data-unique]');
    if(itemsBuild.length > 0){
        let iteration = 0;
        itemsBuild.each(function(){
            if(initIteration===0&&iteration===0){
              iteration++;
            }
            const bcpoContainer = $(this);
            const bcpoLabel = bcpoContainer.find(".bcpo-label");
            let isItemVisible = bcpoLabel.is(":visible");
            if(iteration > 1 && isItemVisible){
              hideAllComponents = false;
              if(firstStepAv === -1){
                firstStepAv = iteration;
              }
            }
            if(iteration === componentToShow && !isItemVisible){
              isNextStepAv = false;
            }
            if(iteration > componentToShow && !isNextStepAv && isItemVisible){
              isNextStepAv = true;
              componentToShow = iteration;
            }
            if(isItemVisible){
              lastItemVisible = iteration;
            }
            iteration++;
        });
    }
    
    if(lastItemVisible<componentToShow && isNextStepAv){
      isNextStepAv = false;
    }
    
    let submitIsDisabled = false;
    if($('.product-form__info-content .product-form__inventory.inventory').length){
      const inventory = $('.product-form__info-content .product-form__inventory.inventory').html().toUpperCase();
      if(inventory==="AGOTADO"){
        submitIsDisabled = true;
      }
    }
    
    if (hideAllComponents) {
      $('.group-builder-trigger--all').hide();
      $('body').removeClass("is-modal-build");
      $('.group-builder-trigger-1').append('<button type="button" class="btn-build-submit" '+(submitIsDisabled?'disabled="disabled"':'')+'>'+(submitIsDisabled?'Agotado':'Añadir al carrito')+'</button>');
    } else {
      $('.group-builder-trigger--all').show(500);
      $('body').addClass("is-modal-build");
      $('.group-builder-trigger-1 .btn-build-submit').remove();
      if(!$("#mostrardiv").length){
        $('.group-builder-trigger--all').append('<div id="mostrardiv" onclick="cerrarModal()"></div>');
      }
      if(parseInt(currentStep)===1 && firstStepAv > 2){
        $(".group-builder-trigger-2").find(".is-item-visible").removeClass("is-item-visible");
        $(".group-builder-trigger-2").attr("data-currstep", firstStepAv);
        $(".group-builder-trigger-2").find('[data-step="'+firstStepAv+'"]').addClass("is-item-visible");
      }
    }
    
    if(!isNextStepAv){
      	let htmlSubmit = '';
      	htmlSubmit += '<button type="button" class="btn-build-submit" '+(submitIsDisabled?'disabled="disabled"':'')+'>'+(submitIsDisabled?'Agotado':'Añadir al carrito')+'</button>';
      	$('.group-builder-trigger-4').html(htmlSubmit);
        $('.btn-prev-next-build-steps.next').attr('disabled', 'disabled');
    }else{
        $('.btn-prev-next-build-steps.next').removeAttr('disabled');
        if($('.btn-build-submit').length){
          $('.btn-build-submit').remove();
        }
    }
    
    $('.group-builder-trigger-3 .footer-price').html($('.product-form__info-content .price.money').html());
  }
};

function cerrarModal() {
  $('.group-builder-trigger--all').toggle();
  location.reload();
  return false;
}

/*
$('.button.button--primary.button--builder-trigger.button--builder-box[for=virtual45325963428780-0]').click(function () {
    var modal = document.getElementsByClassName('.group-builder-trigger--all');

    if (modal.style.display === "none") {
        modal.style.display = "block";
    } else {
        modal.style.display = "none";
    }
})
$('.button.button--primary.button--builder-trigger.button--builder-box[for=virtual45325963428780-0]').on('click', function () {
    var modal = document.getElementsByClassName('.group-builder-trigger--all');

    if (modal.style.display === "none") {
        modal.style.display = "block";
    } else {
        modal.style.display = "none";
    }
});
*/

/*function modalClose(){
  $('.group-builder-trigger--all').toogle();
}*/

/* //        close modal   
function modalClose() {
 var modalvar = $('.group-builder-trigger--all').show(500);
 //let hideAllComponents = true;
 if (modalvar) {
    $('.group-builder-trigger--all').hide(500); 
   	//hideAllComponents = false;
    $('.button.button--primary.button--builder-trigger.button--builder-box[for=virtual45325963428780-1]').addClass('is-checked');
    $('.button.button--primary.button--builder-trigger.button--builder-box[for=virtual45325963428780-0]').removeClass('is-checked');
 }
}*/

$(document).on("change", '.build-dw-config input[type="file"]', function(e){
  let htmlFile = '';
  htmlFile += '<span class="file-name">'+$(this)[0].files[0].name+'</span>';
  htmlFile += '<span class="file-delete"><span data-file="'+$(this).attr("name")+'">Eliminar archivo</span></span>';
  
  const labelName = $('label[data-file="'+$(this).attr("name")+'"]');
  if(labelName.length){
    labelName.addClass("is-file-uploaded");
    labelName.html(htmlFile);
  }
});

$(document).on("click", ".button--builder-trigger .file-delete span", function(e){
  e.preventDefault();
  const file = $('input[name="'+$(this).attr("data-file")+'"]');
  const label = $('label[data-file="'+$(this).attr("data-file")+'"]');
  file.val('');
  label.removeClass("is-file-uploaded");
  label.html('Haz click aquí para cargar tu archivo');
  return false;
});

$(document).on("click", ".button--builder-trigger", function(e){
  e.preventDefault();
  const buttonElStep = $(this);
  if(typeof(buttonElStep.attr("disabled"))!=="undefined"){
    return;
  }
  const currentStep = buttonElStep.attr('data-step');
  if(buttonElStep.hasClass("button--builder-file")){
    if(buttonElStep.hasClass("is-file-uploaded")){
      return false;
    }
    const inputFileName = buttonElStep.attr("data-file");
    const inputFile = $('input[name="'+inputFileName+'"]');
    inputFile.trigger("click");
    
    /* ACTIVA O DESACTIVA BOTONES NEXT Y SUBMIT */
    groupSelector.triggerButtonClick(currentStep);
  }else{
    if(!$("#"+buttonElStep.attr("for")).is(":checked")){

      if($('.build-error').length){
        $('.build-error').remove();
      }
      if(buttonElStep.parent().find(".is-checked").length > 0){
        let hasNextStep = false;
        const itemsPrepareToShow = $('.group-builder-trigger-2 .prepared-to-show');
        for(let i=0; i<itemsPrepareToShow.length; i++){
          if(hasNextStep){
            $(itemsPrepareToShow[i]).removeClass('is-item-visible');
            $(itemsPrepareToShow[i]).find(".is-checked").removeClass("is-checked");
          }
          if($(itemsPrepareToShow[i]).hasClass('is-item-visible')){
            hasNextStep = true;
          }
        }
      }

      $("#"+buttonElStep.attr("for")).trigger("click");
      buttonElStep.parent().find(".is-checked").removeClass("is-checked");
      buttonElStep.addClass("is-checked");

      /* ACTIVA O DESACTIVA BOTONES NEXT Y SUBMIT */
      groupSelector.triggerButtonClick(currentStep);
    }//endif
  }
});

$(document).on('click', '.btn-prev-next-build-steps', function(e){
  e.preventDefault();
  if($('.build-error').length){
    $('.build-error').remove();
  }
  const currStep = $('.group-builder-trigger-2').attr('data-currstep');
  if($(this).hasClass('prev')){
    let numberPreviewStep = -1;
    let showPreviewStep = false;
    const itemsPrepareToShow = $('.group-builder-trigger-2 .prepared-to-show');
    for(let i = (itemsPrepareToShow.length-1); i>=0; i--){
      if(showPreviewStep){
        numberPreviewStep = parseInt($(itemsPrepareToShow[i]).attr('data-step'));
        break;
      }
      if($(itemsPrepareToShow[i]).hasClass('is-item-visible')){
        showPreviewStep = true;
      }
    }
    if(numberPreviewStep > -1){
      $('.data-builder-item--container[data-step="'+currStep+'"]').removeClass('is-item-visible');
      $('.data-builder-item--container[data-step="'+numberPreviewStep+'"]').addClass('is-item-visible');
      $('.group-builder-trigger-2').attr('data-currstep', numberPreviewStep);
      $('.btn-prev-next-build-steps.next').removeAttr('disabled');
      if($('.btn-build-submit').length){
        $('.btn-build-submit').remove();
      }
    }
    if(parseInt(numberPreviewStep)===2){
      $('.btn-prev-next-build-steps.prev').hide();
    }
    
  }else if($(this).hasClass('next')){
    if($('[data-step="'+currStep+'"] .button--builder-trigger.is-checked').length>0){
      $('.btn-prev-next-build-steps.prev').show();
      /* DESENCADENANTE */
      const currentStep = $('.group-builder-trigger-2').attr("data-currstep");
      groupSelector.triggerChangeStep(currentStep);
    }else{
      $('.group-builder-trigger-3').append('<div class="build-error">Por favor seleccione una opción</div>');
    }
  }
});
$(document).on('click', '.btn-build-submit', function(e){
  e.preventDefault();
  if($('.product-block-list__item--build form[action="/cart/add"] [type="submit"]').length){
    $(this).html('Cargando...');
    $('.product-block-list__item--build form[action="/cart/add"] [type="submit"]').trigger('click');
  }else{
    top.location.reload();
  }
});
$(document).on('click', '.btn-prev-next-build-steps', function(e){
  e.preventDefault();
  if($(this).hasClass("btn-visited")){
    $(this).removeClass("btn-visited");    
  }else{
    $(this).addClass("btn-visited"); 
  }
});

$(document).ready(function(){
  console.log(groupSelector.nameApp+" "+groupSelector.version);
  if($("#groupMiniCart").length){
    $("#groupMiniCart").find(".count").text(groupSelector.variants.length);
    $("#groupMiniCart").find(".limit").text(groupSelector.max_selects);
  }
  if(localStorage.getItem("variantsjs")){
    //groupSelector.variants = JSON.parse(localStorage.getItem("variantsjs"));
    let variantsFounded = [];
    const currVariantsJS = JSON.parse(localStorage.getItem("variantsjs"));
    for(var i=0; i<currVariantsJS.length; i++){
      let currVariantId = currVariantsJS[i];
      if($('.product-variants-home option[value="'+currVariantId+'"]').length){
        let currOption = $('.product-variants-home option[value="'+currVariantId+'"]');
        let currSelect = currOption.parent();
        let variant_id = parseInt(currVariantId);
        let product_id = parseInt(currOption.attr("data-productid"));
        let currButton = $('.add-to-group[data-productid="'+product_id+'"]');
        let url_img = currSelect.attr("data-image-url");
        let option_title = currOption.attr("data-title");

        currButton.addClass("added-in-group");
        
        let htmlMiniCartGroup = '';
        htmlMiniCartGroup += '<div class="item" id="item_'+variant_id+'" data-variantid="'+variant_id+'" data-productid="'+product_id+'">';
        htmlMiniCartGroup += '<img src="'+url_img+'" alt="'+option_title+'"/>';
        htmlMiniCartGroup += '<a href="javascript:void(0);" class="remove-item">'+option_title+'<a/>';
        htmlMiniCartGroup += '</div>';
        $(".groupMiniCart-items--lines").append(htmlMiniCartGroup);
        
        variantsFounded.push(currVariantId);
      }
    }//end for
    
    $("#groupMiniCart").find(".count").text(variantsFounded.length);
    let strNotificacion = "<p>LLEVAS {1} TE FALTAN {2}</p>";
    strNotificacion = strNotificacion.replace("{1}", variantsFounded.length);
    strNotificacion = strNotificacion.replace("{2}", (groupSelector.max_selects-variantsFounded.length));
    $(".coll-toolbar").html(strNotificacion);
    groupSelector.variants = variantsFounded;
    //localStorage.setItem("variantsjs", JSON.stringify(variantsFounded));
  }
  if(localStorage.getItem('variantsTime')){
    const variantsTime = parseInt(localStorage.getItem('variantsTime'));
    const currentTime = (new Date()).getTime();
    const diffTime = Math.round((currentTime - variantsTime)/ (1000*60*60));
    if(diffTime>1){
      localStorage.removeItem('variantsTime');
      localStorage.removeItem('variantsjs');
      setTimeout(function(){
        top.location.reload();
      }, 500);
    }
  }
  
  /*Landing Page 20200828*/
  $('.slider-in-landing-page').flickity();

  if($('.product-block-list__item--build').length){
    groupSelector.formatProductBuilder();
  }     
});


$(document).on("click", ".add-to-group", function(e){
  e.preventDefault();
  let btn = $(this);
  let product_id = btn.attr("data-productid");
  let cboProductVariants = $("#product_variants_"+product_id+" option");
  let divMessage = btn.parent().find(".message-product-container");
  let optionSelecteds = btn.parent().find('input[type="radio"]:checked');
  
  if(!$(this).hasClass('added-in-group') && groupSelector.variants.length === 4){
    return false;
  }
  
  if(optionSelecteds.length){
    let option_1 = "", option_2 = "", option_3 = "", option_title = "", url_img = cboProductVariants.attr("data-image-url");
    
    if(typeof url_img !=="undefined"){
      url_img = url_img.replace('{width}', '120');
    }
    
    optionSelecteds.each(function(){
      let rdBtn = $(this);
      if(typeof(rdBtn.attr("data-image-url"))!=="undefined"){
        url_img = rdBtn.attr("data-image-url").replace('{width}', '120');
      }
      switch(rdBtn.attr("data-option")){
        case "0": 
          option_1 = rdBtn.val();
          break;
        case "1": 
          option_2 = rdBtn.val();
          break;
        case "2": 
          option_3 = rdBtn.val();
          break;
      }
    });
    
    let strVariantId = "";
    cboProductVariants.each(function(){
      let _option = $(this);
      let _invQty = parseInt(_option.attr("data-qty"));
      if(_option.attr("data-option1")===option_1 
         && _option.attr("data-option2")===option_2 
         && _option.attr("data-option3")===option_3 
         && _invQty > 0){
        strVariantId = _option.attr("value");
        option_title = _option.attr("data-title");
      }
    });
    if(strVariantId===""){
      groupSelector.showMessage(divMessage, '¡Lo sentimos!<br>Este marco no está disponible');
    }else{
      let strNotificacion = "<p>LLEVAS {1} TE FALTAN {2}</p>";
      let variant_id = parseInt(strVariantId);
      if(groupSelector.variants.indexOf(variant_id)===-1 && groupSelector.variants.length < groupSelector.max_selects){
        btn.addClass("added-in-group");
        groupSelector.variants.push(variant_id);
        localStorage.setItem("variantsjs", JSON.stringify(groupSelector.variants));
        $("#groupMiniCart").find(".count").text(groupSelector.variants.length);
        groupSelector.showMessage(divMessage, '¡Buena elección!<br>Agregamos ese marco a tu prueba');
        let htmlMiniCartGroup = '';
        htmlMiniCartGroup += '<div class="item" id="item_'+variant_id+'" data-variantid="'+variant_id+'" data-productid="'+product_id+'">';
        	htmlMiniCartGroup += '<img src="'+url_img+'" alt="'+option_title+'"/>';
        	htmlMiniCartGroup += '<a href="javascript:void(0);" class="remove-item">'+option_title+'<a/>';
        htmlMiniCartGroup += '</div>';
        $(".groupMiniCart-items--lines").append(htmlMiniCartGroup);
        
        if(!localStorage.getItem("variantsTime")){
          const currentDate = new Date();
          localStorage.setItem("variantsTime", currentDate.getTime());
        }
      }
      else {
        var pos = groupSelector.variants.indexOf(variant_id);
        btn.removeClass("added-in-group");
        groupSelector.variants.splice(pos,1);
        $("#groupMiniCart").find(".count").text(groupSelector.variants.length);
        groupSelector.showMessage(divMessage, 'Sabemos que elegir sólo 4 es difícil.<br>¡Este marco pa’ la otra!');
        $("#item_"+variant_id).remove();
      }
      strNotificacion = strNotificacion.replace("{1}", groupSelector.variants.length);
      strNotificacion = strNotificacion.replace("{2}", (groupSelector.max_selects-groupSelector.variants.length));
      $(".coll-toolbar").html(strNotificacion);
    }
  }
});
$(document).on("click", "#video_play", function(e){
  e.preventDefault();
  $(".video-section").addClass("playing-video");
  document.getElementById("myVideo").play();
});
$(document).on("click", "#video_stop", function(e){
  e.preventDefault();
  $(".video-section").removeClass("playing-video");
  document.getElementById("myVideo").pause();
});
$(document).on("click", "#groupMiniCart", function(e){
  e.preventDefault();
  //return false;
  let minicartItems = $(this).parent().find(".groupMiniCart-items");
  if(!minicartItems.hasClass("groupMiniCart-items--active")){
  	minicartItems.addClass("groupMiniCart-items--active");
  }else{
    minicartItems.removeClass("groupMiniCart-items--active");
  }
});
$(document).on("click", ".groupMiniCart-container .closestyle", function(e){
  e.preventDefault();
  $(this).parent().parent().removeClass("groupMiniCart-items--active");
});
$(document).on("click", ".addToCarProductPrueba", function(e){
  e.preventDefault();
  let btn = $(this);
  btn.attr("disabled", "disabled");
  if(groupSelector.variants.length<groupSelector.max_selects){
  	$('body').addClass("is-modal");
    $('#modalErrorGroup').attr("aria-hidden", "false");
    btn.removeAttr("disabled");
  }else{
	//groupSelector.getCart();
    groupSelector.clearCart();
  }
});
$(document).on("click", '.groupMiniCart-items--lines .remove-item', function(e){
  e.preventDefault();
  let item = $(this).parent();
  let variant_id = parseInt(item.attr("data-variantid"));
  let product_id = parseInt(item.attr("data-productid"));
  let btn = $(".add-to-group[data-productid="+product_id+"]");
  let pos = groupSelector.variants.indexOf(variant_id);
  btn.removeClass("added-in-group");
  groupSelector.variants.splice(pos,1);
  localStorage.setItem("variantsjs", JSON.stringify(groupSelector.variants));
  $("#groupMiniCart").find(".count").text(groupSelector.variants.length);
  $("#item_"+variant_id).remove();
  let strNotificacion = "<p>LLEVAS {1} TE FALTAN {2}</p>";
  strNotificacion = strNotificacion.replace("{1}", groupSelector.variants.length);
  strNotificacion = strNotificacion.replace("{2}", (groupSelector.max_selects-groupSelector.variants.length));
  $(".coll-toolbar").html(strNotificacion);
});
$(document).on("click", '[data-action="close-modal"]', function(e){
  e.preventDefault();
  $('body').removeClass("is-modal");
  $('#modalErrorGroup').attr("aria-hidden", "true");
});
$(document).on("click",'.btn-prueba-en-casa', function(e){
  e.preventDefault();
  $(this).html("Agregando...");
  let url = $(this).attr("data-url");
  let variant_id = parseInt($("#bcpo-select").val());
  if(groupSelector.variants.indexOf(variant_id)===-1 && groupSelector.variants.length < groupSelector.max_selects){
    groupSelector.variants.push(variant_id);
    localStorage.setItem("variantsjs", JSON.stringify(groupSelector.variants));
  }
  top.location.href = url;
});
/*
$(document).on("click",'a[data-action="decrease-quantity"]', function(e){
  e.preventDefault();
  const currItem = $(this).attr("data-line-id");
  const partItem = currItem.split(":");
  if(localStorage.getItem("variantsjs") && partItem.length==2){
    let hasPruebaEnCasa = false;
    const pruebaEnCasaItems = JSON.parse(localStorage.getItem("variantsjs"));
    if(pruebaEnCasaItems.indexOf(parseInt(partItem[0]))!==-1){
      let arrItemsRemove = [];
      $('a[data-action="decrease-quantity"]').each(function(){
        let itemLine = $(this).attr("data-line-id");
        let partLine = itemLine.split(":");
        if(pruebaEnCasaItems.indexOf(parseInt(partLine[0]))!==-1 && arrItemsRemove.indexOf(parseInt(partLine[0]))===-1){
          arrItemsRemove.push(itemLine);
        }
      });
      if(arrItemsRemove.length>0){
        groupSelector.removeItemAll(arrItemsRemove);
      }
    }
  }//end if
});
*/
